module.exports = __webpack_public_path__ + "static/media/glowna_foto_mobile.f97d28c8.jpg";